import React from 'react'
import { Portal } from 'react-portal'
import { useDispatch } from "react-redux"
import { setIsOpen } from "../Actions/Navigation.action"
import MiniCartContainer from '../Containers/MiniCart.container'
import { translate } from '../Services/translation'
import NavigationMobileToggleButton from './NavigationMobileToggleButton'
import NavigationSearchButton from './NavigationSearchButton'

const Navigation = React.forwardRef((props, ref) => {
    const { logoUrl, logoLightUrl, startPageUrl, active, isMobile, isLoggedIn, myPageUrl, loginPageUrl, contentLinks, rightContentLinks, showMiniCart } = props

    const [activeMenu, setActiveMenu] = React.useState()
    const [mouseOverLink, setMouseOverLink] = React.useState(false)
    const [mouseOverMenu, setMouseOverMenu] = React.useState(false)
    const [bottomOfNavbar, setBottomOfNavbar] = React.useState(0)

    const getLinkElement = (link, i) => {
        return <a className={["navbar__link", (activeMenu == i ? "navbar__link--active" : "")].join(" ")} 
            href={link.url} 
            onMouseEnter={() => handleMouseEnterLink(link)} 
            onMouseLeave={() => handleMouseLeaveLink()}
            key={link.url+i+link.name}>
                {link.icon && <i className={"icon icon-"+link.icon}></i>}
                {link.extraInfo != "myPagesLink" && link.extraInfo != "cartLink" ? link.name : ""}
        </a>
    }

    const getLinkElementFromComponent = (component, key) => {
        return <div className={["navbar__link navbar__link--react-component", (activeMenu == component ? "navbar__link--active" : "")].join(" ")}
            onMouseEnter={() => handleMouseEnterLink(component)} 
            onMouseLeave={() => handleMouseLeaveLink()}
            key={key}>
                {component}
        </div>
    }

    const handleMouseEnterLink = link => {
        if(!isMobile) {
            setMouseOverLink(true)
            setActiveMenu(link)
        }
    }

    const handleMouseLeaveLink = () => {
        setMouseOverLink(false)
    }

    const getLeftLinks = () => {
        var linkElements = []
        if(!isMobile) {
            contentLinks.map((link, i) => linkElements.push(getLinkElement(link, i)))
        }else{
            linkElements.push(
                getLinkElementFromComponent(<NavigationMobileToggleButton />, "mobile-toggle-btn"),
                getLinkElementFromComponent(<NavigationSearchButton isMobile={isMobile} />, "mobile-search-btn")
            )
        }
        return linkElements
    }

    const getRightLinks = () => {
        var linkElements = []
        if(!isMobile) {
            rightContentLinks.map((link, i) => linkElements.push(getLinkElement(link, i)))
            linkElements.push(
                getLinkElementFromComponent(<NavigationSearchButton isMobile={isMobile} buttonText={translate("search.navbar-link")} />, "search-btn")
            )
        }

        linkElements.push(
            <a className="navbar__link"
                href={isLoggedIn ? myPageUrl : loginPageUrl}
                onMouseEnter={() => handleMouseEnterLink("myPageLink")} 
                onMouseLeave={() => handleMouseLeaveLink()}
                key={"myPageLink"}
                aria-label={isLoggedIn ? "My pages" : "Sign in"}>
                    <i className="icon icon-user"></i>
            </a>
        )

        if(showMiniCart) {
            linkElements.push(getLinkElementFromComponent(<MiniCartContainer bottomOfNavbar={bottomOfNavbar} />, "mini-cart"))
        }

        return linkElements
    }

    React.useEffect(() => {
        if(!mouseOverLink && !mouseOverMenu) {
            setActiveMenu(undefined)
        }
    }, [mouseOverLink, mouseOverMenu])

    React.useEffect(() => {
        if(!ref || !ref.current) return

        var boundingRect = ref.current.getBoundingClientRect()
        setBottomOfNavbar(boundingRect.y + boundingRect.height)
    }, [ref])

    const generateMegaMenus = () => contentLinks.map((link, i) => link.links && link.links.length > 0 &&
        <Portal node={document && document.querySelector("#mega-menu-container")} key={"megamenu"+i}>
            <div className={"mega-menu" + (activeMenu == link ? " mega-menu--visible" : "")} 
                onMouseEnter={() => setMouseOverMenu(true)}
                onMouseLeave={() => setMouseOverMenu(false)}
                style={{top: bottomOfNavbar}}>
                <div className="row">
                    <div className={"column medium-12 mega-menu__items-wrapper" + (link.megaMenuImageLinkBlocks && link.megaMenuImageLinkBlocks.length > 0 ? " medium-large-8" : "")}>
                    {link.links.map((category, i) => 
                        <div className="mega-menu__item" key={"megamenu-category"+i}>
                            <a className="mega-menu__category-header" href={category.url}>{category.name}</a>    
                            <div className="mega-menu__category-links">
                                {category.links && category.links.map((categoryChild, i) => 
                                    <a href={categoryChild.url} key={"megamenu-category-child"+i}>{categoryChild.name}</a>    
                                )}
                            </div>
                        </div>
                    )}
                    </div>
                    {link.megaMenuImageLinkBlocks && link.megaMenuImageLinkBlocks.length > 0 && 
                        <div className="column show-for-medium-large medium-large-4 mega-menu__image-link-block-wrapper">
                            {link.megaMenuImageLinkBlocks && link.megaMenuImageLinkBlocks.map((block, i) => 
                                <a className="mega-menu__image-link-block" href={block.url} key={link.url+"megamenu-image-block"+i}>
                                    <img src={block.imageUrl} loading="lazy" />
                                    <div className="mega-menu__image-link-block-content">
                                        <div className="pre-header__xsmall">{block.preTitle}</div>
                                        <div className="display-header__small">{block.title}</div>
                                    </div>
                                </a>
                            )}
                        </div>
                    }
                </div>
            </div>
        </Portal>
    )

    const isActive = () => {
        return typeof activeMenu != 'undefined' || active
    }

    return <div className={"navbar" + (isActive() ? " navbar--active" : "")} ref={ref}>
        <div className="row navbar__items-wrapper">
            <div className="navbar__left">
                {contentLinks && getLeftLinks()}
            </div>
            <div className="navbar__logo">
                <a href={startPageUrl}>
                    {!isActive() && <img src={logoLightUrl ? logoLightUrl : logoUrl} alt="Light logo" width="56" height="56" className="navbar__logo-light" />}
                    <img src={logoUrl ? logoUrl : logoLightUrl} width="56" height="56" alt="Logo" className="navbar__logo-dark" />
                </a>
            </div>
            <div className="navbar__right">
                {contentLinks && getRightLinks()}
            </div>
        </div>
        {contentLinks && !isMobile && generateMegaMenus()}
    </div>
})

export default Navigation;